import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { usePWAInstall } from "./hooks/usePWAInstall";
import { useState, useEffect } from "react";

const Layout = () => {
  const { isReady, installApp } = usePWAInstall();
  const [bannerVisible, setBannerVisible] = useState(true);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100 position-relative">
      {/* {isReady && bannerVisible && isMobile && (
        <div
          className={`install-banner position-relative start-50 translate-middle-x shadow-lg`}
        >
          <div className="install-banner-inner">
            <span className="install-banner-logo">LabArtseener</span>
            <span className="me-auto text-white fw-bold">
              Install <strong>Artseener Lab</strong> <br />
              <small style={{ fontSize: "10px" }}>Artist tools, offline</small>
            </span>
            <div className="d-flex align-items-center">
              <button
                onClick={installApp}
                className="btn btn-sm btn-light fw-bold"
              >
                Install App
              </button>
              <span
                onClick={() => setBannerVisible(false)}
                className="ms-3 my-auto"
              >
                <i className="fas fa-close"></i>
              </span>
            </div>
          </div>
        </div>
      )} */}

      <Navbar />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
